import { shiftUrl } from "../Config/Url";
import axios from "axios";

export const shiftService = {
  get,
  create,
  remove,
};

async function get({
  storeId,
  searchText,
  pageIndex,
  pageSize,
  sortName,
  isAsc,
}) {
  return axios
    .get(`${shiftUrl}/${storeId}`)
    .then((res) => res)
    .catch((err) => err.response);
}


async function create({ storeId, name, day, from, to }) {
  return axios
    .post(shiftUrl, {
      storeId,
      name,
      day,
      from,
      to,
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function remove(shiftId) {
  return axios
    .delete(`${shiftUrl}/${shiftId}`)
    .then((res) => res)
    .catch((err) => err.response);
}
